// extracted by mini-css-extract-plugin
export default {"root":"styles__root--w7AGj"};